"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var zl_1 = require("../../model/zl");
var service_1 = require("../../../library/base/service");
var NewsList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(NewsList, _super);
    function NewsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '新闻咨询列表';
        _this.code = '106019';
        _this.desc = '新闻咨询列表';
        _this.requestParams = new zl_1.NewsListRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return NewsList;
}(service_1.BaseService));
exports.NewsList = NewsList;
//# sourceMappingURL=newsList.js.map